<ul ngbNav class="nav nav-pills flex-column">
  <li [ngbNavItem]="mailbox.mailboxAddress" *ngFor="let mailbox of mailboxes;">
    <a ngbNavLink (click)="openTasksForMailbox(mailbox.mailboxAddress)" class="text-right">
      <span class="float-left">{{mailbox.mailboxAddress}}</span>
      <span class="badge badge-secondary">{{mailbox.tasksCount}}</span>
    </a>
  </li>
</ul>

